import { render, staticRenderFns } from "./MobileSteps.vue?vue&type=template&id=2054e2cc&"
import script from "./MobileSteps.vue?vue&type=script&lang=js&"
export * from "./MobileSteps.vue?vue&type=script&lang=js&"
import style0 from "./MobileSteps.vue?vue&type=style&index=0&id=2054e2cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports